import { FC } from 'react';

import { ButtonProps } from './ButtonInterface';
import ButtonStyle from './ButtonStyle';

const typeMap = {
  primary: 'primary' as const,
  secondary: 'ghost' as const,
  link: 'link' as const,
};

const Button: FC<ButtonProps> = ({ type = 'primary', ...props }) => {
  const nativeType = typeMap[type];
  return <ButtonStyle type={nativeType} {...props} />;
};

export default Button;
